import { Navigate, useLocation } from 'react-router-dom';

// ── Helpers ───────────────────────────────────────────────────────────────────
export function getAuthUser() {
  try {
    const token = localStorage.getItem('cst_token');
    const user  = localStorage.getItem('cst_user');
    if (!token || !user) return null;
    return JSON.parse(user);
  } catch {
    return null;
  }
}

export function getAuthToken() {
  return localStorage.getItem('cst_token');
}

export function logout() {
  localStorage.removeItem('cst_token');
  localStorage.removeItem('cst_user');
}

// ── ProtectedRoute ────────────────────────────────────────────────────────────
// roles     — allowed roles for this route
// loginPath — where to redirect if not logged in (role-specific login page)
//
// Usage:
//   <ProtectedRoute roles={['admin','superadmin']} loginPath="/admin/login">
//     <AdminDashboard />
//   </ProtectedRoute>

export default function ProtectedRoute({ children, roles = [], loginPath = '/admin/login' }) {
  const location = useLocation();
  const user = getAuthUser();

  // Not logged in → go to the role-specific login page
  if (!user) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Logged in but wrong role → redirect to their own dashboard
  if (roles.length > 0 && !roles.includes(user.role)) {
    const dashboardMap = {
      superadmin: '/admin',
      admin:      '/admin',
      instructor: '/instructor',
      student:    '/student',
    };
    return <Navigate to={dashboardMap[user.role] || '/'} replace />;
  }

  return children;
}